module.exports = __webpack_public_path__ + "img/qr-code-scan-icon.e99f32dd.svg";